// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "memories-" + chunkId + ".js?v=" + {"vendors-node_modules_webworker-typed_dist_index_js-node_modules_workbox-expiration_index_mjs":"d19c857e832ee4832a08","components_frame_XImgWorker_ts":"e82a91b91c722ba7b046"}[chunkId] + "";
};